<template>
  <div class="home">
    <mynav1 :data='nvdata'></mynav1>
    <!-- <imgct></imgct> -->
    <div id="pmd1">
      <div>智慧地产销售解决方案  </div>
      <label>成就创新\智慧生活 </label>
    </div>
    <div id="pmd2">
      <div>方案概述</div>
    </div>
    <div id="pmd3">
      <div>解决问题</div>
    </div>
    <div id="pmd4">
      <div>智慧地产解决方案实施服务</div>
    </div>
    <div id="pmd5">
      <div>核心服务</div>
    </div>
    <div id="pmd6">
      <div>方案价值</div>
    </div>
    <div id="pmd7">
      <div>实际应用情况</div>
    </div>
    <myfooter :data='ftdata'></myfooter>
  </div>
</template>
<style>
#pmd1 {
  height: 9rem;
  background-image: url('../assets/pic/solve/property/bg1.jpg');
  background-size: 100% 100%;
  overflow: hidden;
  color: white;
}
#pmd1 div {
  font-size: .6rem;
  font-weight: normal;
  margin-top: 3.31rem;
  margin-left: 3.78rem;
}
#pmd1 label {
  font-size: .24rem;
  letter-spacing: .5rem;
  margin-top: .15rem;
  margin-left: 3.78rem;
}

#pmd2 {
  height: 9rem;
  background-image: url('../assets/pic/solve/property/bg2.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#pmd2 div {
  font-size: .36rem;
  color: white;
  font-weight: bold;
  margin-top: 1.1rem;
  text-align: center;
}

#pmd3 {
  height: 9rem;
  background-image: url('../assets/pic/solve/property/bg3.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#pmd3 div {
  font-size: .36rem;
  color: white;
  font-weight: bold;
  margin-top: 1.3rem;
  text-align: center;
}

#pmd4 {
  height: 9rem;
  background-image: url('../assets/pic/solve/property/bg4.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#pmd4 div {
  font-size: .36rem;
  color: white;
  font-weight: bold;
  margin-top: 1.3rem;
  text-align: center;
}

#pmd5 {
  height: 9rem;
  background-image: url('../assets/pic/solve/property/bg5.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#pmd5 div {
  font-size: .36rem;
  color: white;
  font-weight: bold;
  margin-top: .62rem;
  text-align: center;
}

#pmd6 {
  height: 9rem;
  background-image: url('../assets/pic/solve/property/bg6.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#pmd6 div {
  font-size: .36rem;
  color: white;
  font-weight: bold;
  margin-top: 1.3rem;
  text-align: center;
}

#pmd7 {
  height: 9rem;
  background-image: url('../assets/pic/solve/property/bg7.png');
  background-size: 100% 100%;
  overflow: hidden;
}
#pmd7 div {
  font-size: .36rem;
  color: white;
  font-weight: bold;
  margin-top: 1.3rem;
  text-align: center;
}

</style>
<script>
// @ is an alias to /src
require('@/assets/zt.css')
import mynav1 from '@/components/mynav1'
import myfooter from '@/components/footer'
// import imgct from '@/components/solve/property'




export default {
  components: {
    mynav1,myfooter
  },
  data () {
    return {
      ovscroll: false,
      scrdist: 0,
      ftdata: {
        type: 'product',
        lcallback: () => {
          this.init()
        }
      },
      nvdata: {
        sindex: 1,
        type: 'solution',
        lcallback: (stype,sstype) => {
          this.setHead(stype,sstype)
        }
      }
   
    }
  },
  computed: {
  
  },
  methods: {

    onPageScroll (dist) {
      this.ovscroll = dist>93?true:false
      if (dist - this.scrdist > 93) {
        this.scrdist = dist
      } else if (dist < this.scrdist) {
        this.scrdist = dist
      }
      if (dist>0) this.ismenu=false
    },
    setRem() {
        var html = document.querySelector('html');
        var width = html.getBoundingClientRect().width;
        html.style.fontSize = width/20 + 'px'; /// 20
    },
    initWindowEv () {
      /// rem=px/2/14
      window.addEventListener('orientationchange', this.setRem);
      window.addEventListener('resize', this.setRem);
      this.setRem()

      var _this = this
      // var index = 1
      window.onscroll = function (e) {
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
        _this.onPageScroll(scrollTop)
      }
    },
  
    init () {
      var stype = this.$route.query.stype?this.$route.query.stype:''
      this.setHead(stype)
    }
  },
  mounted () {
    this.initWindowEv()
    this.init()
  }
}
</script>
